import React from "react";
import styles from './CloudToken.module.scss'
import { formatDate } from "../../../../application/side/components/renderHelpers";
import Button from "../../../../../components/ripple/Button";

export default function CloudToken({token, onDelete}) {
    return (
        <div className={styles.token}>
            <p className={styles.token__title}>
                {
                    token.cloud_token || token.cloud_key || token.cloud_secret
                    || `${currentCloud.name || currentCloud.code} token ${token.id}`
                }
            </p>
            <time className={styles.token__time}>{formatDate(token.created_at)}</time>
            <Button
                className={styles.token__delete}
                icon='far fa-trash-alt'
                displayType='text'
                onClick={() => onDelete({tokenID: token.id, remove: true})}
            />
        </div>
    )
}